import { AssetDto } from '@picflow/types';
import { Rect } from '../classes/rect.class';
import { assetSideMenuSize } from '../consts';
import { devicePixelRatio } from './device-pixel-ratio';

const getDataBackup = () => {
  return { width: 250 * devicePixelRatio(), height: 250 * devicePixelRatio() };
};

export const GetBounds = (
  offsetScale: number,
  scale: number,
  sideMenuOpen: boolean,
  asset: AssetDto,
  offsetX: number,
  offsetY: number,
  isDesktop: boolean
): Rect => {
  const _scale = offsetScale * scale;
  const width = window.innerWidth - (sideMenuOpen && isDesktop ? assetSideMenuSize : 0);
  const height = window.innerHeight * (!isDesktop && sideMenuOpen ? 0.3 : 1);

  const data = asset.version_data.data || getDataBackup();
  const bounds = new Rect(0, 0, data.width * _scale, data.height * _scale);

  bounds.x += width / 2;
  bounds.x -= bounds.width / 2;
  bounds.y += height / 2;
  bounds.y -= bounds.height / 2;
  bounds.x += offsetX * scale;
  bounds.y += offsetY * scale;

  return bounds;
};
